import React, { FC } from 'react';

import { useKeycloak } from '@react-keycloak/web';
import { BotaoClean } from 'view/component/Botao/Botao';
import { NotificacaoServicos } from 'view/component/NotificacaoServicos/NotificacaoServicos';
import { Busca } from '../Busca/Busca';

import { DEVELOPMENT } from 'util/Dev';
import './barra-superior.css'

export const BarraSuperior: FC = () => {

  const {keycloak} = useKeycloak();

  const sair = <BotaoClean id="botao-sair" onClick={() => keycloak.logout()}>Sair</BotaoClean>;

  return (
    <section id="barra-superior">
      {DEVELOPMENT && <Busca />}

      <nav>
        {DEVELOPMENT && <NotificacaoServicos />}

        {!!keycloak.authenticated && sair}
      </nav>
    </section>
  )
}
